import React from 'react';

import generatePassword from "password-generator";
import copy from "copy-to-clipboard";

// styling
import './RegisterNewUser.css';

// material components
import {
    Button,
    TextField,
    FormLabel,
    FormGroup,
    Checkbox,
    Divider
} from "@material-ui/core";

// constants
import {
    SELECT_SERVICES,
    CANCEL,
    SAVE_ACTION,
    ROLE_DEPTH_AND_ORDER,
    PARENT_ROLE_MAP,
    CHILD_ROLE_MAP,
    ROLE_DASHBOARD,
    ROLE_ADMIN,
    ROLE_SUPERVISOR,
    ROLE_LABEL_OVERRIDES,
    orderRolesForDisplay,
    PASSWORD_ACTION,
    TIME_ZONE,
} from "./constants";
import PropTypes from "prop-types";
import { Autocomplete } from '@material-ui/lab';

class RegisterNewUser extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            firstname: '',
            lastname: '',
            authorities: [ROLE_DASHBOARD],
            company: '',
            password: '',
            timezone: 'America/Chicago',
            employeePerHour: '',
            employeeColor: '',
        }

    }



    handleEdit = (value, name) => {
        this.setState({
            [name]: value
        })
    }

    handleChange = (value, name) => {
        this.setState({
            [name]: value
        })
    }

    createPassword = () => {
        const newPassword = generatePassword(16, false, /[\d\W\w\p]/g).toString()
        this.setState({
            password: newPassword,
            copied: true
        })
        copy(newPassword)
    }

    selectAuthority = (role) => {
        if(role === ROLE_ADMIN){
            if(this.state.authorities.includes(role)){
                this.setState({
                    authorities: [ROLE_DASHBOARD]
                })
            }else{
                this.setState({
                    authorities: [ROLE_ADMIN]
                })
            }
            return
        }

        // Supervisor is a marker role that grants edit-without-delete across
        // modules. It does not affect granular role assignments.
        if(role === ROLE_SUPERVISOR){
            const set = new Set(this.state.authorities)
            if(set.has(ROLE_SUPERVISOR)){
                set.delete(ROLE_SUPERVISOR)
            } else {
                set.add(ROLE_SUPERVISOR)
            }
            this.setState({ authorities: Array.from(set) })
            return
        }

        let newAuthority = new Set(this.state.authorities)
        const updateChild = (isDelete, role) => {
            if(isDelete){
                if(PARENT_ROLE_MAP[role]){
                    PARENT_ROLE_MAP[role].forEach(child => {
                        newAuthority.delete(child)
                    })
                }
                if(CHILD_ROLE_MAP[role]){
                    CHILD_ROLE_MAP[role].forEach(parent => {
                        if (!PARENT_ROLE_MAP[parent]) return
                        let hasChild = false
                        PARENT_ROLE_MAP[parent].forEach(child => {
                            if(newAuthority.has(child)){
                                hasChild = true
                            }
                        })
                        if(!hasChild){
                            newAuthority.delete(parent)
                        }
                    })
                }
            }else{
                if(PARENT_ROLE_MAP[role]){
                    PARENT_ROLE_MAP[role].forEach(child => {
                        newAuthority.add(child)
                    })
                }
                if(CHILD_ROLE_MAP[role]){
                    CHILD_ROLE_MAP[role].forEach(parent => {
                        newAuthority.add(parent)
                    })
                }
            }
        }
        if(!this.state.authorities.includes(role)){
            this.props.allRoles.forEach(roleInAllRole => {
                if(role === roleInAllRole){
                    newAuthority.add(roleInAllRole)
                    updateChild(false, roleInAllRole)
                }
                if(this.state.authorities.includes(roleInAllRole)){
                    newAuthority.add(roleInAllRole)
                }
            });
        }else{
            newAuthority.delete(role)
            updateChild(true, role)
        }
        
        this.setState({
            authorities: Array.from(newAuthority)
        })
    }




    getChecked = (role) => {
        return this.state.authorities.includes(role)
    }


    getLabel = (label) => {
        if (ROLE_LABEL_OVERRIDES[label]) return ROLE_LABEL_OVERRIDES[label]
        let words = label.split('_')
        words.splice(0, 1)
        words = words.map(word => {
            return word[0].toUpperCase() + word.slice(1).toLowerCase()
        })
        return words.join(' ')
    }

    getSpace = (role) => {
        let spaces = []
        for (let index = 0; index < ROLE_DEPTH_AND_ORDER[role]; index++) {
            spaces.push("space")
        }
        return spaces.map(space => {
            return <div className="authority-space"/>
        })
    }

    registerUser = () => {
        copy(this.state.password)
        const data = {
            admin: this.props.admin.username,
            is_linked_user: true,
            username: this.state.username,
            firstname: this.state.firstname,
            lastname: this.state.lastname,
            displayName: this.state.firstname + " " + this.state.lastname,
            authorities: this.state.authorities,
            company: this.state.company,
            password: this.state.password,
            timezone: this.state.timezone,
            employeePerHour: this.state.employeePerHour,
            employeeColor: this.state.employeeColor,

        }
        this.props.register(data)
        this.props.handleClose()
    }

    render() {


        return (
          <div className="row-register-new-user" style={{ marginTop: '40px' }}>
            <div className="rowSpec">
              <TextField
                className="register-new-user-Input"
                variant="outlined"
                label="Email Address"
                InputLabelProps={{ shrink: true }}
                name="username"
                value={this.state.username}
                onChange={(e) =>
                  this.handleChange(e.target.value, e.target.name)
                }
              />
            </div>
            <div className="rowSpec">
              <TextField
                className="register-new-user-TwoInput"
                variant="outlined"
                label="First Name"
                InputLabelProps={{ shrink: true }}
                name="firstname"
                value={this.state.firstname}
                onChange={(e) =>
                  this.handleChange(e.target.value, e.target.name)
                }
              />
              <TextField
                className="register-new-user-TwoInput"
                variant="outlined"
                label="Last Name"
                InputLabelProps={{ shrink: true }}
                name="lastname"
                value={this.state.lastname}
                onChange={(e) =>
                  this.handleChange(e.target.value, e.target.name)
                }
              />
            </div>
            <div className="rowSpec">
              <TextField
                disabled
                className="register-new-user-TwoInput"
                variant="outlined"
                label="Display Name"
                InputLabelProps={{ shrink: true }}
                name="displayName"
                value={`${this.state.firstname} ${this.state.lastname}`}
              />
              <Autocomplete
                options={TIME_ZONE}
                getOptionLabel={(entry) => entry}
                autoHighlight={true}
                className="register-new-user-TwoInput"
                value={this.state.timezone}
                onChange={(event, value) => {
                  this.handleChange(value, 'timezone');
                }}
                name="timezone"
                blurOnSelect={true}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Time zone"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    name="timezone"
                  />
                )}
              />
            </div>
            <div className="rowSpec">
              <TextField
                className="register-new-user-TwoInput"
                variant="outlined"
                label="Password"
                InputLabelProps={{ shrink: true }}
                name="password"
                type="password"
                value={this.state.password}
                onChange={(e) =>
                  this.handleChange(e.target.value, e.target.name)
                }
                autoComplete="new-password"
              />
              <Button
                className="register-new-user-TwoInput"
                value={this.state.password}
                color="secondary"
                variant="contained"
                onClick={() => {
                  this.createPassword();
                }}
              >
                {PASSWORD_ACTION}
              </Button>
            </div>

            <div className="rowSpec">
              <TextField
                className="register-new-user-TwoInput"
                variant="outlined"
                label="Employee Per Hour Rate"
                InputLabelProps={{ shrink: true }}
                name="employeePerHour"
                value={this.state.employeePerHour}
                onChange={(e) => this.handleEdit(e.target.value, e.target.name)}
                type="number"
              />

              <TextField
                className="register-new-user-TwoInput"
                variant="outlined"
                label="Employee Color"
                InputLabelProps={{ shrink: true }}
                name="employeeColor"
                value={this.state.employeeColor}
                onChange={(e) => this.handleEdit(e.target.value, e.target.name)}
              />
            </div>



            <Divider className="divider" />
            <div className="register-new-user-role-box">
              <FormLabel component="legend">{SELECT_SERVICES}</FormLabel>
              <FormGroup>
                {orderRolesForDisplay(this.props.allRoles).map((role, i) => {
                  return (
                    <div className="authority-box">
                      {this.getSpace(role)}
                      <Checkbox
                        disabled={
                          role === ROLE_DASHBOARD ||
                          this.state.authorities.includes(ROLE_ADMIN)
                        }
                        checked={this.getChecked(role)}
                        onChange={() => this.selectAuthority(role)}
                        name="authority"
                        color="primary"
                      />
                      <div
                        className={
                          role === ROLE_DASHBOARD ||
                          this.state.authorities.includes(ROLE_ADMIN)
                            ? 'authority-text-disabled'
                            : ''
                        }
                      >
                        {this.getLabel(role)}
                      </div>
                    </div>
                  );
                })}
                <div className="authority-box">
                  {this.getSpace(ROLE_SUPERVISOR)}
                  <Checkbox
                    disabled={this.state.authorities.includes(ROLE_ADMIN)}
                    checked={this.getChecked(ROLE_SUPERVISOR)}
                    onChange={() => this.selectAuthority(ROLE_SUPERVISOR)}
                    name="authority"
                    color="primary"
                  />
                  <div
                    className={
                      this.state.authorities.includes(ROLE_ADMIN)
                        ? 'authority-text-disabled'
                        : ''
                    }
                  >
                    Supervisor (edit only, cannot delete)
                  </div>
                </div>
                <div className="authority-box">
                  {this.getSpace(ROLE_ADMIN)}
                  <Checkbox
                    checked={this.getChecked(ROLE_ADMIN)}
                    onChange={() => this.selectAuthority(ROLE_ADMIN)}
                    name="authority"
                    color="primary"
                  />
                  <div className="authority-text">
                    {this.getLabel(ROLE_ADMIN)}
                  </div>
                </div>
              </FormGroup>
            </div>

              <div style={{ marginBottom: '24px' }}>
                  <Button
                      variant="outlined"
                      onClick={this.props.handleClose}
                      className="register-new-user_btn"
                  >
                      {CANCEL}
                  </Button>
                  <Button
                      disabled={!(this.state.password?.length > 0)}
                      variant="contained"
                      color="primary"
                      onClick={this.registerUser}
                      className="register-new-user_btn"
                  >
                      {SAVE_ACTION}
                  </Button>
              </div>
          </div>
        );
    }

}

RegisterNewUser.propTypes = {
    admin: PropTypes.object,
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    register: PropTypes.func
}

RegisterNewUser.defaultProps = {
    admin: {},
    open: false,
    handleClose: () => {
    },
    register: () => {
    }
}

export default RegisterNewUser;